import * as React from "react";
const SvgTriangleLeftFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.632 13.65a2 2 0 0 1-.09-2.826c.044-.047.044-.047.09-.091L13.17 5.54A2 2 0 0 1 16.538 7v10.384a2 2 0 0 1-3.368 1.459z", clipRule: "evenodd" }));
export default SvgTriangleLeftFill;
